<template>
  <div class="page">
    <div class="weui-tab">
      <div class="weui-navbar">
          <div @click="tabClick(0)" class="weui-navbar__item " :class="[activeIndex === 0 ? 'weui-bar__item_on' : '']">进行中</div>
          <div @click="tabClick(1)" class="weui-navbar__item" :class="[activeIndex === 1 ? 'weui-bar__item_on' : '']">完成</div>
        </div>
        <div class="weui-tab__content" v-if="activeIndex === 0">
          <div class="record-item" @click="toWordAccess(item)" v-for="(item,index) in assessList">
            <div class="record-title-container">
              <img class="title-rili-icon"
                   src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_riqi@2x.png"/>
              <div class="record-title">{{ item.title }}</div>
              <div class="record-item-time">{{ item.begin_time }}</div>
            </div>
            <div class='record-item-content'>
              <div class="key-content-left">
                <!-- 测评关键内容信息 -->
                <div class="key-content">
                  <img class="icon-ch"
                       src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_moshi@2x.png"/>
                  <text class="record-rule">{{ item.mode }}</text>
                  <img class="icon-ch"
                       src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_danci@2x.png"/>
                  <text class="record-rule">单词：{{ item.words_num }}</text>
                </div>
                <div class="record-deadline-time">截止时间：{{ item.end_time }}</div>
              </div>
              <img class="record-item-status-done 111" v-if="item.status===1"
                   src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_ywc@2x.png">
              <img class="record-item-status 222" v-else-if="item.status===2"
                   src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_jxz@2x.png">
            </div>
          </div>
          <div class="nodata" style="text-align:center;" :class="[(assessList.length>0)?'hidden':'']">
            <img src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_kong@2x.png"/>
            <div class='notext'>暂时没有新的测评信息哦~</div>
          </div>
        </div>
        <div class="weui-tab__content" v-if="activeIndex === 1">
          <div class="record-item" @click="toWordAccess(item)" v-for="(item,index) in assessList">
            <div class="record-title-container">
              <img class="title-rili-icon"
                   src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_riqi@2x.png"/>
              <div class="record-title">{{ item.title }}</div>
              <div class="record-item-time">{{ item.begin_time }}</div>
            </div>
            <div class='record-item-content'>
              <div class="key-content-left">
                <div class="key-content">
                  <img class="icon-ch"
                       src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_moshi@2x.png" />
                  <text class="record-rule">{{ item.mode }}</text>
                  <img class="icon-ch"
                       src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_danci@2x.png" />
                  <text class="record-rule">单词：{{ item.words_num }}</text>
                </div>
                <div class="record-deadline-time">截止时间：{{ item.end_time }}</div>
              </div>
              <img title="已经完成" class="record-item-status-done 11111" v-if="item.status===1"
                   src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_ywc@2x.png" />
              <img title="进行中" class="record-item-status" v-else-if="item.status===2"
                   src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_jxz@2x.png" />
              <img title="未完成" class="record-item-status-not" v-else-if="item.status===3"
                   src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_wwc@2x.png"/>
            </div>
          </div>
          <div class="nodata" style="text-aglin:center;" :class="[(assessList.length>0)?'hidden':'']">
            <img src="https://777-wx-res.oss-cn-beijing.aliyuncs.com/word_test/icon_cplb_kong@2x.png" alt="">
            <div class='notext'>暂时没有新的测评信息哦~</div>
          </div>
        </div>
      </div>
    </div>
</template>
<style lang="less" scoped>
.page {
  background: #ffffff;
  margin: 0 auto;
  width:700px;
}


/* tab总的样式修改 */
.weui-navbar {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
}

.weui-navbar__item{
  flex: 1;
  text-align: center;
  padding: 1rem;
  color:rgba(6, 58, 26, 1);
  font-weight: bolder;
  background-color: rgba(226,245,238,1);
}

/* tab项选中颜色 */
.weui-navbar__item.weui-bar__item_on {
  background-color: #18CE8E;
  color: #fff;
}


.weui-tab__content {

}


/* 排课记录条目 */

.record-item {
  width: 700px;
  height: 254px;
  background: #fff;
  box-shadow: 0px 4px 10px 0px rgba(235, 235, 235, 0.5);
  border-radius: 16px;
  margin-top: 26px;
}

.hidden {
  display: none !important;
}

.record-title-container {
  width: 700px;
  height: 92px;
  background: linear-gradient(222deg, #0AC684 0%, #23C275 100%);
  box-shadow: 0px 4px 10px 0px rgba(235, 235, 235, 0.5);
  border-radius: 16px 16px 0px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title-rili-icon {
  width: 64px;
  height: 56px;
  margin-left: 16px;
}

.record-title {
  width: 364px;
  height: 44px;
  font-size: 30px;
  font-family: PingFangSC-, PingFang SC;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 44px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  text-align: left;
  margin-left: 10px;
}

.record-item-time {
  font-size: 22px;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 40px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}

.record-item-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.key-content-left {
  display: flex;
  flex-direction: column;
}

.key-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 22px;
  margin-top: 28px;
}

.icon-ch {
  width: 40px;
  height: 40px;
}

.record-rule {
  width: 156px;
  font-size: 28px;
  font-family: PingFangSC-, PingFang SC;
  font-weight: bold;
  color: #4B4B4B;
  line-height: 40px;
  text-align: left;
  margin-left: 6px;
}

.record-deadline-time {
  font-size: 26px;
  color: #606060;
  line-height: 36px;
  margin-left: 28px;
  margin-top: 28px;
}

.record-item-status, .record-item-status-done, .record-item-status-not {
  width: 120px;
  height: 120px;
  margin-right: 20px;
}


/* 无数据的 */
.nodata {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 5rem;
}

.nodata image {
  width: 300px;
}

.notext {
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #606060;
  margin-top: 18px;
}
</style>
<script>
import { mapState, mapMutations } from 'vuex'
import { getAssessListRecord } from '../../services'

export default {
  name: 'word_competition',
  components: {},
  data () {
    return {
      type: 1,
      activeIndex: 0,
      sliderOffset: 0,
      sliderLeft: 0,
      imageurl: 'https://777-wx-res.oss-cn-beijing.aliyuncs.com/',
      assessList: [],
      page: 1,
      hasMoreData: false,
      status: 0, // 测评状态  1已完成；  2待测试； 3未完成
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  watch: {},
  created () {
    this.tabClick(0);
  },
  methods: {
    tabClick: function (index) {
      if(index===0){
        this.type = 1
        this.page = 1
        this.activeIndex=0;
      }
      if(index===1){
        this.type = ''
        this.page = 1
        this.activeIndex=1;
      }
      this.loadData()
    },
    loadData: function () {
      getAssessListRecord({
        type: this.type,
        page: this.page
      }).then((res) => {

        let assessList = res.assessList
        let list = res.data.list
        let maxPage = res.data.page.maxPage
        if (this.page === 1) {
          assessList = []
        }
        if (this.page >= maxPage) {
          this.assessList = assessList.concat(list)
          this.hasMoreData = false
        } else {
          this.assessList = assessList.concat(list)
          this.hasMoreData = true
          this.page = this.page + 1
        }

      })
    },
    toWordAccess:function(item){
      let index = item.index;
      let id = item.id;
      let status =item.status;
      if(status===1){
        this.$router.push({
          path: '/word_competition_result',
          query: {
            id: id,
          }
        })
      }else if(status===3){
        alert('当前测试已过测评时间');
      }else{
        this.$router.push({
          path: '/word_competition_id',
          query: {
            id: id,
          }
        })
      }
    },
  },
}
</script>
